export const getImagePreview = (file: File | string): string => {
	if (typeof file === 'string') return file;
	return URL.createObjectURL(file);
};

export const convertBlobToBase64 = (blob: any) => {
	const reader = new FileReader();
	reader.readAsDataURL(blob);
	return new Promise((resolve) => {
		reader.onloadend = () => {
			resolve(reader.result);
		};
	});
};
